
<div class="pl-2 pr-2">
  <p><b>{{ alert?.header }}</b></p>
  <p *ngIf="alert?.text">{{ alert?.text }}</p>
  <ul *ngIf="alert?.bulletPoints?.length">
    <li *ngFor="let point of alert?.bulletPointsList">{{ point }}</li>
  </ul>
  <p *ngIf="alert?.footer">{{ alert?.footer }}</p>
</div>